const styles = () => ({
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  invitees: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    maxWidth: '570px',
    display: 'block'
  },
  invitee: {
    display: 'inline-block',
    margin: '0 2px 8px',
    padding: '5px 10px',
    borderRadius: '24px',
    border: '1px solid #ddd'
  },
  spinner: {
    width: '25px',
    height: '25px'
  },
  msgIcon: {
    position: 'relative',
    top: '-1px',
    marginLeft: '5px',
    color: '#686764'
  }
})

export default styles
